import type { ComponentProps, PropsWithChildren } from 'react';

import { VStack, chakra } from '@chakra-ui/react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

import LoadingLottie from '@/assets/lotties/generating-your-results.lottie';

const DotLottieReactStyled = chakra(DotLottieReact);

export const LoaderAnimated: React.FC<
  PropsWithChildren<ComponentProps<typeof DotLottieReactStyled>>
> = ({ children, ...rest }) => {
  return (
    <VStack>
      <DotLottieReactStyled
        w={{ base: '200px', lg: '300px' }}
        h={{ base: '200px', lg: '300px' }}
        src={LoadingLottie}
        loop
        autoplay
        {...rest}
      />
      {children}
    </VStack>
  );
};
